import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { jwtDecode } from 'jwt-decode';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private defaultApiUrl = environment.apiUrl;
  private token: string = '';
  constructor(private http: HttpClient, private authService: AuthService, private router: Router) {
    this.authService.idTokenClaims$.subscribe(token => {
      this.token = token?.__raw || '';
    });
  }

  private getHeaders(): HttpHeaders {
    const decodedToken = jwtDecode(this.token) as any;
    if (decodedToken.user_metadata.guid_credipal) {
      return new HttpHeaders({
        'Authorization': `Bearer ${this.token}`
      });
    } else {
      this.router.navigate(['/registro-exitoso']);
      //this.authService.logout();
      return new HttpHeaders();
    }
  }

  getData(endpoint: string, baseUrl: string = this.defaultApiUrl): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(baseUrl + endpoint, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  postData(data: any, endpoint: string, baseUrl: string = this.defaultApiUrl): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(baseUrl + endpoint, data, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  postFile(data: any, endpoint: string, baseUrl: string = this.defaultApiUrl): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.token}`
    });
    return this.http.post(baseUrl + endpoint, data, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  deleteData(endpoint: string, baseUrl: string = this.defaultApiUrl): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(baseUrl + endpoint, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  updateData(data: any, endpoint: string, baseUrl: string = this.defaultApiUrl): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(baseUrl + endpoint, data, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ha ocurrido un error.';

    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = error.error?.Message || errorMessage;
    }

    if (this.router.url !== '/registro-exitoso') {
      Swal.fire({
        title: 'Oops!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }

    console.error('Error en la solicitud:', error);
    return throwError(errorMessage);
  }
}
